import api from "./axios-setup/axios";

// Login user
/**
 * Login user and store JWT token in localStorage
 * @param {object} payload - { email, password }
 * @returns {Promise<{ user: object, expires_in: number }>} Logged-in user and token info
 */
export const loginUser = async (payload) => {
  const response = await api.post("/users/login", payload);
  const { access_token, user, expires_in } = response.data;

  localStorage.setItem("access_token", access_token);
  // localStorage.setItem("user", JSON.stringify(user));
  localStorage.setItem("org_id", user.org_id);
  localStorage.setItem("user_role", user.role);
  return { user, expires_in };
};

// Change password
/**
 * Change password for the logged-in user
 * @param {object} payload - { current_password, new_password }
 * @returns {Promise<{ detail: string }>} Success message
 */
export const changePassword = async (payload) => {
  const response = await api.post("/users/change-password", payload);
  return response.data;
};

// Register a new user
/**
 * Register a new user
 * @param {object} payload - { name, email, password }
 * @returns {Promise<object>} Newly created user
 */
export const registerNewUser = async (payload) => {
  const response = await api.post("/users", payload);
  return response.data;
};

// get all users

/**
 * Get all users with pagination
 * @param {number} [page=1] - Page number
 * @param {number} [page_size=10] - Number of users per page
 * @returns {Promise<object[]>} Array of users
 */
export const getUsers = async (page = 1, page_size = 10) => {
  const response = await api.get("/users", {
    params: { page, page_size }, // axios will convert these params like this /users?page=1&page_size=10
  });
  return response.data;
};

// get user by id

/**
 * Get a single user by ID
 * @param {number|string} id - User ID
 * @returns {Promise<object>} User data
 */
export const getUserById = async (id) => {
  const response = await api.get(`/users/${id}`);
  return response.data;
};
// example
// const user = await getUserById(13);
// console.log(user);

// update user by id

/**
 * Update a user by ID
 * @param {number|string} id - User ID
 * @param {object} payload - Fields to update, e.g., { name, email, role }
 * @returns {Promise<object>} Updated user
 */
export const updateUserById = async (id, payload) => {
  const response = await api.put(`/users/${id}`, payload);
  return response.data;
};

// delete user by id

/**
 * Delete a user by ID
 * @param {number|string} id - User ID
 * @returns {Promise<object>} Response from server
 */
export const deleteUserById = async (id) => {
  const response = await api.delete(`/users/${id}`);
  return response.data;
};

export const logoutUser = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("user");
  localStorage.removeItem("org_id");
  localStorage.removeItem("user_role");
};
